const breakingNewsStyle = Object.freeze({
  buttonVariant: 'primaryOpaque',
});

export default breakingNewsStyle;
